<template>
    <div class="preloader" v-if="show">
        <div class="preloader__box"></div>
    </div>
</template>

<script>
import {mapGetters} from 'vuex';

export default {
    name: 'the-preloader',
    computed: {
        ...mapGetters({
            show: 'preloader/show'
        })
    }
}
</script>

<style lang="scss" scoped>
.preloader {
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.5);   
    display: flex;
    justify-content: center;
    align-items: center;

    &__box {
        width: 120px;
        height: 120px;
        border-radius: 50%;
        border: 3px solid #c5c5c5;
        border-top: 3px solid #262538;
        animation: spin 1.5s linear infinite;
    }
}

@keyframes spin {
    0% {
        transform: rotate(0);
    }
    100% {
        transform: rotate(360deg);
    }
}
</style>